import { createAction, props } from '@ngrx/store';
import { Company } from '../../models/company.model';

export const setCompany = createAction(
    '[Company] Set Company',
    props<{ selectedCompany: Company }>()
);